import ActionTypes from '@utils/deviceActions';
import { TFunction } from 'i18next';

export const getModelDataColumns = (
  actionKey: ActionTypes,
  translate: TFunction,
  isMotBusiness?: boolean,
  variablesData?: string[],
): {
  title: string;
  dataIndex: string;
  key: string;
  validation?: { type: string; length?: number };
}[] => {
  switch (actionKey) {
    case ActionTypes.SEND_SMS:
      if (variablesData) {
        return [
          {
            title: 'MSISDN',
            dataIndex: 'msisdn',
            key: 'msisdn',
          },
          ...(variablesData || []).map(item => ({
            title: item,
            dataIndex: item,
            key: item,
          })),
        ];
      }
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
        },
      ];
    case ActionTypes.ACTIVATION_MOT:
      return [
        {
          title: 'ICCID',
          dataIndex: 'iccid',
          key: 'iccid',
          validation: { type: 'number' },
        },

        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
          validation: { type: 'number' },
        },
        {
          title: 'IMSI',
          dataIndex: 'imsi',
          key: 'imsi',
        },
        {
          title: translate('operator'),
          dataIndex: 'vendor',
          key: 'vendor',
        },
      ];
    case ActionTypes.ACTIVATION_MULTI_CONNECT:
      return [
        {
          title: 'ICCID',
          dataIndex: 'iccid',
          key: 'iccid',
          validation: { type: 'number', length: 20 },
        },
      ];
    case ActionTypes.MANUAL_ACTIVATION:
    case ActionTypes.SUSPENSION:
    case ActionTypes.WITHDRAWAL_OF_SUSPENSION:
    case ActionTypes.FORCE_REACTIVATION:
    case ActionTypes.NETWORK_RESET:
    case ActionTypes.CONTRACT_SUSPEND:
    case ActionTypes.PROVISIONAL_WITHDRAW:
    case ActionTypes.SMS_BLOCK:
    case ActionTypes.BROKER_CANCELLATION:
    case ActionTypes.HLR_REPROG:
    case ActionTypes.CONTRACT_MOVEMENT:
    case ActionTypes.IMEI_UNLOCK:
    case ActionTypes.ALGAR_BAIT_RENEWAL:
    case ActionTypes.SYNC_APN:
    case ActionTypes.CANCELLATION:
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
          validation: { type: 'number' },
        },
      ];
    case ActionTypes.SIMCARD_RESET:
    case ActionTypes.PRIORITY_OPERATOR:
    case ActionTypes.OPERATOR_RESTRICTION:
    case ActionTypes.MOT_DEACTIVATION:
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
          validation: { type: 'number' },
        },
        {
          title: 'ICCID',
          dataIndex: 'iccid',
          key: 'iccid',
          validation: { type: 'number' },
        },
      ];
    case ActionTypes.NETWORK_BLOCK:
      return [
        {
          title: 'MSISDN',
          key: 'msisdn',
          dataIndex: 'msisdn',
        },
        {
          title: translate('steps.network-block.block-type'),
          key: 'tpBloqueio',
          dataIndex: 'tpBloqueio',
        },
        {
          title: translate('steps.network-block.initial-validity'),
          key: 'dtInicioBloqueio',
          dataIndex: 'dtInicioBloqueio',
        },
        {
          title: translate('steps.network-block.end-validity'),
          key: 'dtFimBloqueio',
          dataIndex: 'dtFimBloqueio',
        },
      ];
    case ActionTypes.NETWORK_UNLOCK:
      return [
        {
          title: 'MSISDN',
          key: 'msisdn',
          dataIndex: 'msisdn',
        },
        {
          title: translate('steps.network-block.unlock-date'),
          key: 'dtDesbloqueio',
          dataIndex: 'dtDesbloqueio',
        },
      ];

    case ActionTypes.NICKNAME_CHANGE:
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
          validation: { type: 'number' },
        },
        {
          title: 'ICCID',
          dataIndex: 'iccid',
          key: 'iccid',
          validation: { type: 'number' },
        },
        {
          title: translate('steps.nickname-change.nickname'),
          dataIndex: 'nickname',
          key: 'nickname',
        },
      ];
    case ActionTypes.APN_REMOVE:
    case ActionTypes.APN_ADD:
    case ActionTypes.CHANGE_APN:
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
          validation: { type: 'number' },
        },
        {
          title: translate('steps.change-apn.apn'),
          dataIndex: 'apn',
          key: 'apn',
        },
      ];
    case ActionTypes.TRANSFER:
      return [
        {
          title: 'ICCID',
          key: 'iccid',
          dataIndex: 'iccid',
        },
        {
          title: 'MSISDN',
          key: 'msisdn',
          dataIndex: 'msisdn',
        },
        {
          title: translate(
            `steps.transfer.new-${isMotBusiness ? 'grouping' : 'virtual'}-id`,
          ),
          key: 'newCustomerVirtualAccountId',
          dataIndex: 'newCustomerVirtualAccountId',
        },
      ];

    case ActionTypes.PLASTIC_EXCHANGE:
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
        },
        {
          title: 'ICCID',
          dataIndex: 'iccid',
          key: 'iccid',
        },
        {
          title: 'ICCID',
          dataIndex: 'processData',
          key: 'processData',
        },
      ];
    case ActionTypes.MSISDN_EXCHANGE:
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
        },
        {
          title: 'ICCID',
          dataIndex: 'iccid',
          key: 'iccid',
        },
        {
          title: 'MSISDN',
          dataIndex: 'processData',
          key: 'processData',
        },
      ];

    case ActionTypes.ADD_CREDIT_TO_SIMCARD:
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
        },
        {
          title: 'MB',
          dataIndex: 'processData',
          key: 'processData',
        },
      ];
    case ActionTypes.IMEI_LOCK:
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
        },
        {
          title: 'IMEI',
          dataIndex: 'processData',
          key: 'processData',
        },
      ];
    case ActionTypes.FINANCIAL_UNLOCK:
    case ActionTypes.FINANCIAL_LOCK:
      return [
        {
          title: translate('customerId'),
          dataIndex: 'customerId',
          key: 'customerId',
        },
      ];
    default:
      return [];
  }
};

export const getModelData = (actionType: ActionTypes) => {
  switch (actionType) {
    case ActionTypes.ACTIVATION_MOT:
      return [
        {
          key: '1',
          iccid: '89553202000000159564',
          msisdn: '5503404446239',
          vendor: 'TIM',
          imsi: '724320200047910',
        },
        {
          key: '2',
          iccid: '89553202000000159847',
          msisdn: '5503404446239',
          vendor: 'VIVO',
          imsi: '724320200047911',
        },
        {
          key: '3',
          iccid: '89553202000000159489',
          msisdn: '5503404446239',
          vendor: 'CLARO',
          imsi: '724320200047912',
        },
      ];
    case ActionTypes.IMEI_LOCK:
      return [
        {
          key: '1',
          msisdn: '5503404446239',
          processData: '610837348244440',
        },
        {
          key: '2',
          msisdn: '5550030239500',
          processData: '027744873463469',
        },
        {
          key: '3',
          msisdn: '5575315909912',
          processData: '307533703589937',
        },
        {
          key: '4',
          msisdn: '5541857845871',
          processData: '207716526226743',
        },
      ];
    case ActionTypes.FINANCIAL_UNLOCK:
    case ActionTypes.FINANCIAL_LOCK:
      return [
        {
          key: '1',
          customerId: '133213',
        },
        {
          key: '2',
          customerId: '421421',
        },
        {
          key: '3',
          customerId: '321321',
        },
      ];
    case ActionTypes.SUSPENSION:
    case ActionTypes.WITHDRAWAL_OF_SUSPENSION:
    case ActionTypes.FORCE_REACTIVATION:
    case ActionTypes.MANUAL_ACTIVATION:
    case ActionTypes.NETWORK_RESET:
    case ActionTypes.CONTRACT_SUSPEND:
    case ActionTypes.PROVISIONAL_WITHDRAW:
    case ActionTypes.BROKER_CANCELLATION:
    case ActionTypes.CONTRACT_MOVEMENT:
    case ActionTypes.HLR_REPROG:
    case ActionTypes.IMEI_UNLOCK:
    case ActionTypes.ALGAR_BAIT_RENEWAL:
    case ActionTypes.SYNC_APN:
    case ActionTypes.CANCELLATION:
      return [
        {
          key: '1',
          msisdn: '5503404446239',
        },
        {
          key: '2',
          msisdn: '5550030239500',
        },
        {
          key: '3',
          msisdn: '5575315909912',
        },
        {
          key: '4',
          msisdn: '5541857845871',
        },
      ];
    case ActionTypes.SIMCARD_RESET:
    case ActionTypes.PRIORITY_OPERATOR:
    case ActionTypes.OPERATOR_RESTRICTION:
    case ActionTypes.MOT_DEACTIVATION:
      return [
        {
          key: '1',
          iccid: '89553202000000159564',
          msisdn: '5503404446239',
        },
        {
          key: '2',
          iccid: '89553202000000159847',
          msisdn: '5503404446239',
        },
        {
          key: '3',
          iccid: '89553202000000159489',
          msisdn: '5503404446239',
        },
        {
          key: '4',
          iccid: '89553202000000159562',
          msisdn: '5503404446239',
        },
      ];
    case ActionTypes.NETWORK_BLOCK:
      return [
        {
          key: '0',
          msisdn: 551699999999,
          tpBloqueio: 1,
          dtInicioBloqueio: '20211120',
          dtFimBloqueio: undefined,
        },
        {
          key: '1',
          msisdn: 551699999999,
          tpBloqueio: 2,
          dtInicioBloqueio: '20211120',
          dtFimBloqueio: undefined,
        },
        {
          key: '2',
          msisdn: 551699999999,
          tpBloqueio: 3,
          dtInicioBloqueio: '20211120',
          dtFimBloqueio: 20211124,
        },
      ];

    case ActionTypes.NETWORK_UNLOCK:
      return [
        {
          key: '0',
          msisdn: 551699999999,
          dtDesbloqueio: 20220116,
        },
        {
          key: '1',
          msisdn: 551699999999,
          dtDesbloqueio: 20220130,
        },
        {
          key: '2',
          msisdn: 551699999999,
          dtDesbloqueio: 20220201,
        },
      ];

    case ActionTypes.SMS_BLOCK:
      return [
        {
          key: '0',
          msisdn: 551699999999,
          iccid: '89553202000000159562',
        },
        {
          key: '1',
          msisdn: 551699999999,
          iccid: '89553202000000159562',
        },
        {
          key: '2',
          msisdn: 551699999999,
          iccid: '89553202000000159562',
        },
      ];

    case ActionTypes.NICKNAME_CHANGE:
      return [
        {
          key: '1',
          iccid: '89553202000000159564',
          msisdn: '5503404446239',
          nickname: 'ALG1',
        },
        {
          key: '2',
          iccid: '89553202000000159565',
          msisdn: '5503404446239',
          nickname: 'ALG2',
        },
        {
          key: '3',
          iccid: '89553202000000159566',
          msisdn: '5503404446239',
          nickname: 'ALG3',
        },
      ];
    case ActionTypes.APN_REMOVE:
    case ActionTypes.APN_ADD:
    case ActionTypes.CHANGE_APN:
      return [
        {
          key: '1',
          msisdn: '5503404446239',
          apn: 'apn.com.br',
        },
        {
          key: '2',
          msisdn: '5503404446239',
          apn: 'apn.com.br',
        },
        {
          key: '3',
          msisdn: '5503404446239',
          apn: 'apn.com.br',
        },
      ];
    case ActionTypes.MSISDN_EXCHANGE:
      return [
        {
          key: '1',
          iccid: '89553202000000159564',
          msisdn: '5503404446239',
          processData: '5503404446239',
        },
        {
          key: '2',
          iccid: '89553202000000159565',
          msisdn: '5503404446239',
          processData: '5503404446239',
        },
        {
          key: '3',
          iccid: '89553202000000159566',
          msisdn: '5503404446239',
          processData: '5503404446239',
        },
      ];
    case ActionTypes.ADD_CREDIT_TO_SIMCARD:
      return [
        {
          key: '1',
          msisdn: '5503404446239',
          processData: '5',
        },
        {
          key: '2',
          msisdn: '5503404446239',
          processData: '10',
        },
        {
          key: '3',
          msisdn: '5503404446239',
          processData: '15',
        },
      ];
    case ActionTypes.TRANSFER:
      return [
        {
          key: '1',
          iccid: '89553202000000159564',
          msisdn: '5503404446239',
          newCustomerVirtualAccountId: '331',
        },
        {
          key: '2',
          iccid: '89553202000000159565',
          msisdn: '5503404446239',
          newCustomerVirtualAccountId: '322',
        },
        {
          key: '3',
          iccid: '89553202000000159566',
          msisdn: '5503404446239',
          newCustomerVirtualAccountId: '342',
        },
      ];
    case ActionTypes.PLASTIC_EXCHANGE:
      return [
        {
          key: '1',
          iccid: '89553202000000159564',
          msisdn: '5503404446239',
          processData: '89553202000000159565',
        },
        {
          key: '2',
          iccid: '89553202000000159565',
          msisdn: '5503404446239',
          processData: '89553202000000159565',
        },
        {
          key: '2',
          iccid: '89553202000000159565',
          msisdn: '5503404446239',
          processData: '89553202000000159565',
        },
      ];
    default:
      return [];
  }
};
